import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\DownloadDocumentWordByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/DownloadDocumentWordByDossierIdController.php
* @route '/api/dossier/{dossier}/{type}/{document}/download-word'
*/
const DownloadDocumentWordByDossierIdController = (args: { dossier: string | number | { id: string | number }, type: string | number, document: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, type: string | number, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DownloadDocumentWordByDossierIdController.url(args, options),
    method: 'post',
})

DownloadDocumentWordByDossierIdController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/{type}/{document}/download-word',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\DownloadDocumentWordByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/DownloadDocumentWordByDossierIdController.php
* @route '/api/dossier/{dossier}/{type}/{document}/download-word'
*/
DownloadDocumentWordByDossierIdController.url = (args: { dossier: string | number | { id: string | number }, type: string | number, document: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, type: string | number, document: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            type: args[1],
            document: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        type: args.type,
        document: typeof args.document === 'object'
        ? args.document.id
        : args.document,
    }

    return DownloadDocumentWordByDossierIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{type}', parsedArgs.type.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\DownloadDocumentWordByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/DownloadDocumentWordByDossierIdController.php
* @route '/api/dossier/{dossier}/{type}/{document}/download-word'
*/
DownloadDocumentWordByDossierIdController.post = (args: { dossier: string | number | { id: string | number }, type: string | number, document: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, type: string | number, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DownloadDocumentWordByDossierIdController.url(args, options),
    method: 'post',
})

export default DownloadDocumentWordByDossierIdController